import { ChangeEvent, useEffect, useState } from "react";
import { Form, Image } from "react-bootstrap";
import { useIntl } from "react-intl";
import { downLoadFileById, imageUpload } from "../../services/fileServices";
import { toast } from "react-toastify";
import { toAbsoluteUrl } from "../../../../_metronic/helpers";
import { localStorageItem } from "../../utils/localStorage";
import { hasAuthority } from "../../utils/functionUtils";
import { PERMISSIONS, PERMISSION_ABILITY } from "../../../constants";
import { KEY_LOCALSTORAGE } from "../../auth/core/_consts";
import { DEFAULT_IMAGE_TYPES } from "./imageUploadConsts";
type IProps = {
  view: boolean;
  url: string;
  handleUploadAvatar?: (id: string) => void | undefined;
  allowFileTypes?: string[];
  imageType: string;
};

function ImageUploadV2(props: IProps) {
  const { view, handleUploadAvatar, url, allowFileTypes = DEFAULT_IMAGE_TYPES, imageType } = props;
  const intl = useIntl();
  const [imageURL, setImageURL] = useState<string>("");

  useEffect(() => {
    if(!url) return;
    setImageURL(url);
  }, [url]);

  const handleChangeImage = async (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target?.files) {
      const src = URL.createObjectURL(event.target.files[0]);
      setImageURL(src);
      let files = event.target.files[0];
      try {
        const data = await imageUpload(files, imageType);
        if(handleUploadAvatar) {
          const res = await downLoadFileById(data?.data?.data?.id)
          const contentType = res?.headers['content-type'] || 'application/octet-stream';
          const blob = new Blob([res.data], { type: contentType });
          const url = window.URL.createObjectURL(blob);
          handleUploadAvatar(url);
          hasAuthority(PERMISSIONS.USER, PERMISSION_ABILITY.VIEW) 
            && localStorageItem.set(KEY_LOCALSTORAGE.URL_IMAGE_AVATAR, data?.data?.data?.filePath || "");
        }
      } catch (error) {
        toast.error(intl.formatMessage({ id: "GENERAL.ERROR" }));
      }
    }
  };

  return (
    <label className={`${!view && "cursor-pointer"} relative rect-img-container`}>
      <Image src={imageURL || toAbsoluteUrl("/media/avatars/blank.png")} fluid className="rounded-circle rect-img"/>
      <Form.Control
        disabled={view}
        type="file"
        size="sm"
        id="select-file-inp"
        className="d-none"
        onChange={handleChangeImage}
        accept={allowFileTypes.join(',')}
      />
      {!view && (
        <i className="bi bi-camera image-upload-icon text-white fs-1"></i>
      )}
    </label>
  );
}

export default ImageUploadV2;
